import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiMapPin, FiClock, FiArrowRight } from 'react-icons/fi';
import {
  EventsContainer,
  EventsHeader,
  EventsGrid,
  EventCard,
  EventImage,
  EventDate,
  EventContent,
  EventTitle,
  EventInfo,
  EventDescription,
  EventButton,
  LoadingShimmer
} from '../styles/EventsStyle';
import PageLayout from '../components/PageLayout';
import axios from 'axios';
import Footer from '../components/Footer';

function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    // fetch events data
    axios.get('http://localhost:8000/events')
      .then(response => {
        setEvents(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Error fetching events:', error);
        setLoading(false);
      });
  }, []);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return {
      day: date.getDate(),
      month: date.toLocaleString('default', { month: 'short' }).toUpperCase()
    };
  };

  const LoadingCard = () => (
    <EventCard>
      <LoadingShimmer height="250px" />
      <EventContent>
        <LoadingShimmer height="28px" width="70%" margin="0 0 1rem 0" />
        <LoadingShimmer height="20px" width="40%" margin="0 0 1rem 0" />
        <LoadingShimmer height="60px" width="100%" margin="0 0 1rem 0" />
      </EventContent>
    </EventCard>
  );

  return (
    <PageLayout>
      <EventsContainer>
        <EventsHeader>
          <h1>Upcoming Events</h1>
          <p>Join us for exciting exhibitions, talks, workshops, and more. Experience the future of design and creativity at Studio 442.</p>
        </EventsHeader>

        <EventsGrid>
          {loading ? (
            Array(6).fill(null).map((_, index) => <LoadingCard key={index} />)
          ) : (
            events.map((event, index) => {
              const formattedDate = formatDate(event.date);
              return (
                <EventCard key={event._id} index={index}>
                  <EventImage className="event-image">
                    <img src={event.image} alt={event.title} />
                  </EventImage>
                  <EventDate className="event-date">
                    <div className="day">{formattedDate.day}</div>
                    <div className="month">{formattedDate.month}</div>
                  </EventDate>
                  <EventContent>
                    <EventTitle>{event.title}</EventTitle>
                    <EventInfo>
                      <div>
                        <FiMapPin />
                        {event.location}
                      </div>
                      <div>
                        <FiClock />
                        {event.time}
                      </div>
                    </EventInfo>
                    <EventDescription>{event.description}</EventDescription>
                    <EventButton onClick={() => navigate(`/events/${event._id}`)}>
                      Learn More <FiArrowRight />
                    </EventButton>
                  </EventContent>
                </EventCard>
              );
            })
          )}
        </EventsGrid>
        <Footer />
      </EventsContainer>
    </PageLayout>
  );
}

export default Events;
